import { adaptDjangoErrors, APIError } from "./errors";
import { AxiosResponse } from "axios";
import { history } from "../history";

export interface ParsedResponse<T> {
  status: number;
  error: APIError | null;
  data: T | null;
}

export async function getError(resp: AxiosResponse): Promise<APIError> {
  if (resp.status === 400) {
    // Field errors await!
    let fieldErrors = await resp.data;
    fieldErrors = adaptDjangoErrors(fieldErrors);
    let statusMessage = resp.statusText;
    if ("_error" in fieldErrors) {
      statusMessage = fieldErrors._error;
    }
    return { message: statusMessage, body: null, fieldErrors: fieldErrors };
  }
  if (resp.status === 429) {
    return { message: resp.data.detail, body: null, fieldErrors: {} };
  }
  if (resp.status === 401 && resp?.config?.url?.includes("participants/authenticate")) {
    return { message: "PIN is invalid.", body: null, fieldErrors: {} };
  }
  return { message: resp.statusText, body: null, fieldErrors: {} };
}

function redirectUnauthorized(resp: AxiosResponse) {
  if (resp.status === 403 && history.location.pathname !== "/") {
    history.push("/");
  }
}

export async function getParsedResponse<T>(resp: AxiosResponse): Promise<ParsedResponse<T>> {
  if (resp.status >= 200 && resp.status < 300) {
    return { status: resp.status, error: null, data: resp.data };
  }
  redirectUnauthorized(resp);
  return { status: resp.status, error: await getError(resp), data: null };
}
